/* eslint strict: "off" */

module.exports = (function () {
	return this;
}());



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/global.js
// module id = 806
// module chunks = 0